<script>
import { mapGetters } from 'vuex'
import FufuHeader from '@/components/FufuHeader'

export default {
  name: 'FirstSelection',
  components: {
    FufuHeader,
  },
  // NOTE: 店頭予約の場合はstoreに店舗情報が入ってる
  computed: {
    ...mapGetters(['shop']),
  },
}
</script>

<template>
  <div class="fill-height">
    <FufuHeader :shop="shop"> 予約する </FufuHeader>
    <v-container class="white" fill-height>
      <v-row>
        <v-col cols="12">
          <v-flex xs5 class="mx-auto">
            <v-btn
              color="fufuyellow"
              text-color="fufugrey2"
              x-large
              block
              :to="`/reservation/${shop.id}/campaign`"
            >
              初回のお客様
            </v-btn>
          </v-flex>
        </v-col>
        <v-col cols="12">
          <v-flex xs5 class="mx-auto">
            <v-btn
              color="fufuyellow"
              text-color="fufugrey2"
              x-large
              block
              :to="`/reservation/${shop.id}/menu`"
            >
              2回目以降のお客様
            </v-btn>
          </v-flex>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
